// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatateth } from "../../../icons/full/build/icon-statateth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatatethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatateth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatatethIcon.displayName = 'StatatethIcon';
}

export default StatatethIcon;